<template>
  <div class="checkout">
    <!-- HEADER -->
    <div class="checkout-header">
      <span @click="$emit('close')">←</span>
      <b>Tổng quan đơn hàng</b>
    </div>

    <!-- ADDRESS -->
    <div class="block">
      <div class="row-between">
        <b>📍 Địa chỉ nhận hàng</b>
        <span class="edit">›</span>
      </div>
      <div class="text-sm">
        Viên đây (+84)97****54<br />
        The Golden Palm, Lê Văn Lương, Hà Nội
      </div>
      <div class="warning">
        Quận và mã bưu chính đã thay đổi. Hãy chỉnh sửa trước khi đặt hàng.
      </div>
    </div>

    <!-- PRODUCT -->
    <div class="block">
      <div class="row">
        <img :src="image" class="thumb" />
        <div > </div>
        <div class="flex-1">
          <div class="name">{{ product.name }}</div>
          <div class="price">
            {{ formatPrice(product.price) }}₫
          </div>
        </div>

        <!-- QTY -->
        <div class="qty">
          <button @click="qty--" :disabled="qty === 1">-</button>
          <span>{{ qty }}</span>
          <button @click="qty++">+</button>
        </div>
      </div>
    </div>

    <!-- SHIPPING -->
    <div class="block row-between">
      <span>🚚 Vận chuyển</span>
      <span class="free">Miễn phí</span>
    </div>

    <!-- SUMMARY -->
    <div class="summary">
      <div class="row-between">
        <span>Tạm tính</span>
        <span>{{ formatPrice(total) }}₫</span>
      </div>
      <div class="row-between total">
        <span>Tổng</span>
        <span>{{ formatPrice(total) }}₫</span>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="checkout-footer">
      <div>
        <div class="total-price">{{ formatPrice(total) }}₫</div>
        <div class="save">Tiết kiệm 0%</div>
      </div>
      <button class="order-btn">Đặt hàng</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["product"],
  data() {
    return {
      qty: 1
    };
  },
  computed: {
    total() {
      return this.product.price * this.qty;
    },
    image() {
      return this.product.image.split(";")[0];
    }
  },
  methods: {
    formatPrice(v) {
      return v.toLocaleString("vi-VN");
    }
  }
};
</script>

<style scoped>
.checkout {
  position: fixed;
  inset: 0;
  background: #090909;
  color: #fff;
  display: flex;
  flex-direction: column; width: 40%;
}

.checkout-header {
  padding: 12px;
  display: flex;
  gap: 12px;
  border-bottom: 1px solid #333;
}

.block {
  padding: 12px;
  border-bottom: 1px solid #333;
}

.row {
  display: flex;
  gap: 10px;
}
.row-between {
  display: flex;
  justify-content: space-between;
}

.thumb {
  width: 60px;
  height: 60px;
  object-fit: cover;
}

.qty {
  display: flex;
  align-items: center;
  gap: 6px;
}

.qty button {
  width: 26px;
  height: 26px;
}

.summary {
  padding: 12px;
}

.total {
  color: #ff4d6d;
  font-weight: bold;
}

.checkout-footer {
  margin-top: auto;
  padding: 12px;
  background: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-btn {
  background: #ff2c55;
  border: none;
  color: #fff;
  padding: 10px 18px;
  border-radius: 8px;
}
.free {
  color: #00ffb3;
}
.warning {
  background: #3a1c1c;
  color: #ff7b7b;
  padding: 6px;
  margin-top: 6px;
  font-size: 12px;
}
</style>
